import { noop } from "lodash";
import { useHistory } from "react-router-dom";
import I18n from "@/i18n-js/instance";
import {
  useCurrentSpaceContext,
  usePunditUserContext,
  useSpaceResource,
} from "@circle-react/contexts";
import { coursePaths } from "@circle-react/helpers/urlHelpers";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

export const WelcomeBanner = () => {
  const { data: space } = useCurrentSpaceContext();
  const { currentCommunityMember, isLoading, isViewOnlyMasquerading } =
    usePunditUserContext();
  const history = useHistory();
  const { space: spaceResource } = useSpaceResource({
    spaceId: space?.id,
  });

  const totalLessons = spaceResource.course_sections.reduce(
    (total, section) => total + section.lessons.length,
    0,
  );

  const hasCompletedLessons = spaceResource?.course_sections?.some(section =>
    section.lessons.some(lesson => lesson.completed),
  );

  const nextSection = spaceResource?.course_sections?.find(section =>
    section.lessons.find(lesson => !lesson.completed),
  );
  const nextLesson = nextSection?.lessons.find(lesson => !lesson.completed);

  const onStartClick = () => {
    history.push(
      coursePaths.showLesson({
        spaceSlug: space.slug,
        lessonId: nextLesson.id,
        sectionId: nextSection.id,
      }),
    );
  };

  if (isLoading) return null;

  if (!nextLesson && !nextSection) {
    return (
      <Typography.TitleXl>
        {I18n.t("courses.course_completed")}
      </Typography.TitleXl>
    );
  }
  return (
    <div className="flex w-full flex-col items-start justify-between space-y-2 md:flex-row md:items-center">
      <Typography.TitleXl>
        {I18n.t("courses.welcome", {
          name: currentCommunityMember.first_name,
        })}
      </Typography.TitleXl>
      {totalLessons > 0 && (
        <Button
          variant="primary"
          onClick={isViewOnlyMasquerading ? noop : onStartClick}
        >
          {I18n.t(
            hasCompletedLessons
              ? "courses.continue_course"
              : "courses.start_course",
          )}
        </Button>
      )}
    </div>
  );
};
